import { render, staticRenderFns } from "./BarSettings.vue?vue&type=template&id=5ae2f828"
import script from "./BarSettings.vue?vue&type=script&lang=js"
export * from "./BarSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports